<template>
		<!-- 趣味报告标题 -->
	<div class="funreport-title">
		<div class="animal">
			<div class="ch">
				<img v-bind:src="funreport.pic.replace('animal.png', 'animalName.png').replace('../', './')">
			</div>
			<div class="en"></div>
		</div>
	</div>
	<!-- 趣味报告标题 -->
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'funHead',
	computed: mapState({
		funreport: state => state.funreport,
	})
}
</script>
<style scoped lang="scss">
.page-funreport {
	img {
		width: 50%;
	}
  .funreport-title {
		.animal {
			margin-top: 30px;
			text-align: center;
			.ch {
				display: inline-block;
			}
		}
  }
}
</style>



// WEBPACK FOOTER //
// funHead.vue?2edcc5c8